// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"ade2c59e","77":"832701df","123":"b7b13137","501":"d0f872ad","770":"d4f5f147","787":"157219b9","879":"73cbe90c","964":"ef7b338a","985":"403b04c6"}[chunkId] + ".chunk.js";
};